import { Grid, IconButton } from "@mui/material";
import { memo, useState } from "react";
import { useNavigate } from 'react-router-dom';

import Tooltip from '@mui/material/Tooltip';

import { CustomTable } from '../../../components/customTable/customTable';

import { BsEyeFill } from "react-icons/bs";
import { format } from "date-fns";


const RequestedJobs = () => {
    const navigate = useNavigate();
    const [event, setEvent] = useState({})

    const requestHireColumn = [
        {
            name: 'Facility Name',
            valuesName: "FACILITY_NAME",
            selector: row => row.FACILITY_NAME,
            reorder: true,
            sortable: true,
        },
        {
            name: 'Job Role',
            valuesName: "ROLE_NAME",
            selector: row => row.ROLE_NAME,
            reorder: true,
            sortable: true,
            style: { paddingLeft: "20px" }
        },
        {
            name: 'Job Type',
            valuesName: "JOB_TYPE",
            selector: row => row.JOB_TYPE,
            reorder: true,
            sortable: true,

        },
        {
            name: 'Specialty Name',
            valuesName: "SPECIALTY_NAME",
            selector: row => row?.SPECIALTY_NAME,
            reorder: true,
            sortable: true,
        },
        {
            name: 'Job Status',
            valuesName: "JOB_STATUS",
            selector: row => row.adminActionType || row.JOB_STATUS,
            reorder: true,
            sortable: true,
            style: { paddingLeft: "26px" }
        },
        {
            name: 'Added On',
            valuesName: "CREATED_DATE",
            // selector: row => row.CREATED_DATE,
            selector: row => new Date(row?.CREATED_DATE).toDateString(),
            // selector: row => console.log("timeee",row?.CREATED_DATE),
            sortable: true,
            reorder: true,
            style: { paddingLeft: "18px" }
        },

        {
            name: 'Actions',
            button: true,
            cell: row => (
                <div style={{ paddingLeft: "15px" }}>
                    <Tooltip title="View Job">
                        <IconButton size="small" onClick={() => {
                            navigate('/admin/requested-job/view/' + row.ID);
                        }}>
                            <BsEyeFill />
                        </IconButton>
                    </Tooltip>

                </div>
            ),
            reorder: true,
            center: true
        }
    ]

    return (
        <Grid container>
            <Grid item lg={12} mb={2} mt={2}>
                <CustomTable
                    column={requestHireColumn}
                    event={(e) => { setEvent(e) }}
                    url={`/job/fetchRequestedHiringJob`}
                    headline={"Requested Jobs"}

                />
            </Grid>
        </Grid>
    )
}

export default memo(RequestedJobs);
